<template>
  <div class="transfer_record">
    <div class="search_div">
      <el-select
        size="small"
        v-model="searchData.assetType"
        placeholder="请选择类型"
        style="width: 140px; margin-right: 10px"
      >
        <el-option label="全部类型" value=""></el-option>
        <el-option v-for="(item, index) in lableList" :key="index" :label="item[1]" :value="item[0]"></el-option>
      </el-select>
      <el-input
        size="small"
        style="width: 140px; margin-right: 10px"
        v-model="searchData.targetId"
        placeholder="姓名/账号"
      ></el-input>
      <el-date-picker
        v-model="searchData.date"
        type="daterange"
        size="small"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        :default-time="['00:00:00', '23:59:59']"
        @change="dateChangeValue"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-right: 10px"
      />
      <el-button size="small" @click="getList">查询</el-button
      >
      <el-button size="small" @click="resetFn">重置</el-button
      >
    </div>
    <el-table
      :data="transferList"
      style="width: 100%"
      border
      :header-cell-style="{
            background: '#F1F1F1',
            color: '#353535',
            fontWeight: '600',
          }"
      class="table"
    >
      <el-table-column label="操作人" show-overflow-tooltip prop="operationPersonal">
        <template slot-scope="scope">
          {{scope.row.operationPersonal}}（{{scope.row.operationAccount}}）
        </template>
      </el-table-column>
      <el-table-column label="转赠类型" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          {{lableObj[scope.row.assetType]}}
        </template>
      </el-table-column>
      <el-table-column label="IP" show-overflow-tooltip prop="ip"></el-table-column>
      <el-table-column label="转赠量" show-overflow-tooltip prop="transferCount" width="80"></el-table-column>
      <el-table-column label="操作详情" show-overflow-tooltip prop="operationDetail" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.assetType === -1">
            将<span class="red_color">{{scope.row.transferCount}}</span>积分赠送给：<span class="red_color">{{scope.row.receivePersonal}}（{{scope.row.receiveAccount}}）</span>
          </div>
          <div v-else>
            将<span class="red_color">{{scope.row.transferCount}}</span>次{{lableObj[scope.row.assetType]}}套餐赠送给<span class="red_color">{{scope.row.receivePersonal}}（{{scope.row.receiveAccount}}）</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" show-overflow-tooltip prop="operationTime"></el-table-column>
    </el-table>
    <!-- pagination -->
    <el-col :span="24" style="padding: 15px 0; position: relative" class="page-flex-end">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchData.itemPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchData.pageSize"
        layout="sizes, prev, pager, next, total"
        :total="searchData.pageTotal"
      />
      <el-go
        :page-size="searchData.pageSize"
        :total="searchData.pageTotal"
        @current-change="handleCurrentChange"
      ></el-go>
    </el-col>
  </div>
</template>

<script>
  import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
  import ElGo from "../../../components/go/Go";
  import {mapGetters} from "vuex";
    export default {
        name: "transferRecord",
      components: {ElGo},
      data() {
          return {
            lableObj: {},//搜索类型
            transferList: [],
            searchData: {
              itemPage: 1,
              pageSize: 10,
              pageTotal: 0,
              assetType: '',
              targetId: '',
            },
            pickerOptions: {
              disabledDate(time) {
                const one = 30 * 24 * 3600 * 1000;
                const minTime = new Date().getTime();
                const maxTime = new Date().getTime() + one;
                return time.getTime() < minTime || time.getTime() > maxTime;
              }
            },
          }
      },
      computed: {
        ...mapGetters(["allAuthUser", "currentAuthUser"]),
        lableList() {
          return Object.entries(this.lableObj);
        },
      },
      mounted() {
        this.queryUseAblePkgtFn();
        this.getList();
      },
      methods: {
          //日期切换
        dateChangeValue() {

        },
        //查询
        getList() {
          let param = {
            ...this.searchData,
          }
          if (param.date) {
            param.beginDate = '';
            param.endDate = '';
          }
          ApiCorpMethods.LogController.findAssetTransferByPaged(param).then(res => {
            if (res.success) {
              this.transferList = res.data;
              this.searchData.pageTotal = res.total;
            }
          })
        },
        queryUseAblePkgtFn() {
          let param = {};
          if (this.currentAuthUser.corpUserId) {
            param.corpQuery = 1;
          }
          ApiCorpMethods.accountOperationController.queryUseAblePkgt(param).then(res => {
            this.lableObj = res.data;
          })
        },
        //重置
        resetFn() {
          this.searchData = {
            itemPage: 1,
            pageSize: 10,
            assetType: '',
            targetId: '',
          };
          this.getList();
        },
      //  分页
        handleCurrentChange: function(val) {
          this.searchData.itemPage = val;
          this.getList();
        },
        handleSizeChange: function(val) {
          this.searchData.pageSize = val;
          this.getList();
        },
      }
    }
</script>

<style scoped lang="less">
  .transfer_record {
    padding: 0 20px;
  }
  .search_div {
    text-align: right;
    margin: 10px 20px 10px 0;
  }
  .red_color {
    color: #ec1c1c;
  }
</style>



// WEBPACK FOOTER //
// pages/signSettings/components/transferRecord.vue